import { useField } from 'formik'
import { ReactNode } from 'react'
import { Form } from '../../Form'
import { FormItemProps as AntdFormItemProps } from '../../Form'

export type FormItemProps = {
  showValidateSuccess?: boolean
  showInitialErrorAfterTouched?: boolean
  children: ReactNode
} & { name: string } & AntdFormItemProps

export const FormItem = ({
  name,
  showValidateSuccess,
  showInitialErrorAfterTouched = false,
  children,
  ...restProps
}: FormItemProps) => {
  const [, meta] = useField(name)

  const { error, initialError } = meta
  const isTouched = meta.touched

  const hasError = error !== undefined && isTouched
  const hasInitialError = initialError !== undefined
  const isValid = !error && isTouched
  const showHelp =
    hasError ||
    (hasInitialError && (!isTouched || showInitialErrorAfterTouched))

  return (
    <Form.Item
      name={name}
      validateStatus={
        hasError || (hasInitialError && !isTouched)
          ? 'error'
          : isValid && showValidateSuccess
            ? 'success'
            : undefined
      }
      hasFeedback={isValid}
      help={
        showHelp ? (
          <>
            {hasError && <li>{error}</li>}
            {hasInitialError &&
              (!isTouched || showInitialErrorAfterTouched) && (
                <li>{initialError}</li>
              )}
          </>
        ) : undefined
      }
      {...restProps}
    >
      {children}
    </Form.Item>
  )
}
